import type { ReactNode } from 'react';
import { useEffect } from 'react';

import { useAuthStore } from '~/store/auth.store';
import { useTenantStore } from '~/store/tenant.store';

interface TenantProviderProps {
  children: ReactNode;
}

/**
 * Clears tenant configuration when the active tenant changes,
 * so downstream components re-fetch data for the new tenant context.
 */
export function TenantProvider({ children }: TenantProviderProps) {
  const activeTenantId = useAuthStore((s) => s.user?.activeTenantId);
  const config = useTenantStore((s) => s.config);

  useEffect(() => {
    if (!activeTenantId) return;
    if (config?.id === activeTenantId) return;

    // Tenant changed — clear stale config so it can be refreshed
    useTenantStore.getState().clearTenantConfig();
  }, [activeTenantId, config?.id]);

  return <>{children}</>;
}
